module.exports = __webpack_public_path__ + "img/maison7.3887c831.jpg";